export default "ff04ffff0101ff0280\n"